import { render, staticRenderFns } from "./AddOrEditRoute.vue?vue&type=template&id=3f6d409c&scoped=true&"
import script from "./AddOrEditRoute.vue?vue&type=script&lang=js&"
export * from "./AddOrEditRoute.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditRoute.vue?vue&type=style&index=0&id=3f6d409c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d409c",
  null
  
)

export default component.exports